export default "__VITE_ASSET__1$Hhaw1E__"